import { ServiceException, ValidationMessage } from '@src/infrastructure/httpClient/index';
import { Toaster } from '@src/controls/toasts/toaster';
import { Log } from '@src/infrastructure/logging/index';
import { ServerSettings } from '@src/infrastructure/serverSettings';
import { ServerValidationCodes } from '@src/infrastructure/constants/serverValidationCodes';

export class ErrorHandler {
    private readonly log: Log;
    public validationMessages = ko.observableArray<ValidationMessage>([]);

    constructor(serverSettings: ServerSettings) {
        this.log = new Log(serverSettings);
    }

    handleError(e: any) {
        if (e instanceof ServiceException && e.isBusinessException === true) {
            this.mapServiceException(e);
            return;
        } else {
            this.log.exception(e);
            const message = 'There was an unexpected error on the server. Please try again later or contact support.';
            this.validationMessages.push({ code: 'SERVERERROR', message: message });
            Toaster.show('Error', message);
        }
    }

    public errorContainsValidationCode(e: any, serverValidationCode: ServerValidationCodes) {
        if (!(e instanceof ServiceException && e.isBusinessException === true)) {
            return false;
        }
        const serviceException = <ServiceException>e;
        return serviceException.errors.some(e => e.code === serverValidationCode);
    }

    public reset() {
        this.validationMessages.removeAll();
    }

    private mapServiceException(serviceException: ServiceException) {
        if (!serviceException.errors) {
            return;
        }
        if (serviceException.errors.length === 1) {
            Toaster.show('Error', serviceException.errors[0].message);
            return;
        }
        this.validationMessages.push(...serviceException.errors);
    }
}